<!-- 新-主动推送 - 基础设置 -->
<template>
  <div class="new-active-push-settings">
    <div class="page-layout">
      <!-- 左侧三级菜单 -->
      <div class="menu-sidebar" :class="{ 'is-collapsed': menuCollapsed }">
        <nested-menu
          :menu-list="subMenuList"
          :active-key="activeMenuKey"
          :is-collapsed="menuCollapsed"
          @item-click="handleMenuClick"
          @toggle-collapse="handleToggleCollapse"
        />
      </div>
      <!-- 右侧内容区域 -->
      <div class="content-area">
        <div class="page-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NestedMenu from '@/components/nestedMenu'
import { mapGetters } from 'vuex'
export default {
  name: 'NewActivePushSettings',
  components: {
    NestedMenu
  },
  data() {
    return {
      activeMenuKey: '',
      currentMenuKey: '',
      menuCollapsed: false,
      baseMenuList: [
        {
          id: 'ts-pz',
          label: '推送配置',
          path: '/newActivePushSettings/pushConfig'
        },
        {
          id: 'qk-pz',
          label: '期刊配置',
          path: '/newActivePushSettings/journalConfig'
        },
        {
          id: 'pp-sf',
          label: '匹配算法',
          path: '/newActivePushSettings/matchAlgorithm'
        },
        {
          id: 'mb-pz',
          label: '模板配置',
          path: '/newActivePushSettings/settingsTemplateConfig'
        },
        {
          id: 'bmd',
          label: '白名单',
          path: '/newActivePushSettings/whitelist'
        },
        {
          id: 'fj-yxgl',
          label: '发件邮箱管理',
          path: '/newActivePushSettings/senderMailbox'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isMedicalAssociationEnv', 'isCluster']),
    subMenuList() {
      if (!this.isMedicalAssociationEnv || !this.isCluster) {
        return this.baseMenuList.filter((item) => item.id !== 'qk-pz')
      }
      return this.baseMenuList
    },
    activeMenuData() {
      const menuItem = this.subMenuList.find(
        (item) => item.id === this.activeMenuKey
      )
      return menuItem
    }
  },
  watch: {
    $route(to) {
      // 根据路由更新激活的菜单项
      const path = to.path
      const menuItem = this.subMenuList.find((item) =>
        path.includes(item.path.split('/').pop())
      )
      if (menuItem) {
        this.activeMenuKey = menuItem.id
        this.currentMenuKey = menuItem.id
      }
    }
  },
  mounted() {
    // 根据当前路由设置激活菜单
    this.updateActiveMenu()
  },
  methods: {
    handleMenuClick(item) {
      this.activeMenuKey = item.id
      this.currentMenuKey = item.id
      if (item.path) {
        const columnId = this.$route.query.columnId || '10-3' // 新-主动推送 -> 基础设置
        this.$router.push({
          path: item.path,
          query: {
            ...this.$route.query,
            columnId
          }
        })
      }
    },
    updateActiveMenu() {
      const path = this.$route.path
      const isJournalConfig = path.includes('journalConfig')

      if (!this.isMedicalAssociationEnv && !this.isCluster && isJournalConfig) {
        const pushConfigItem = this.baseMenuList.find(
          (item) => item.id === 'ts-pz'
        )
        if (pushConfigItem) {
          this.$router.push({
            path: pushConfigItem.path,
            query: {
              ...this.$route.query,
              columnId: this.$route.query.columnId || '10-3'
            }
          })
          return
        }
      }

      const menuItem = this.subMenuList.find((item) =>
        path.includes(item.path.split('/').pop())
      )
      if (menuItem) {
        this.activeMenuKey = menuItem.id
        this.currentMenuKey = menuItem.id
      } else if (this.subMenuList.length > 0) {
        this.handleMenuClick(this.subMenuList[0])
      }
    },
    getCurrentMenuLabel() {
      const menuItem = this.subMenuList.find(
        (item) => item.id === this.currentMenuKey
      )
      return menuItem ? menuItem.label : ''
    },
    /**
     * 处理菜单收起/展开切换
     */
    handleToggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.new-active-push-settings {
  height: 100%;
  overflow: hidden;

  .page-layout {
    display: flex;
    height: 100%;
  }

  .menu-sidebar {
    width: 120px;
    background-color: #fff;
    border-right: 1px solid #e4e7ed;
    overflow: hidden;
    flex-shrink: 0;
    transition: width 0.3s ease;

    &.is-collapsed {
      width: 60px;
    }
  }

  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .page-header {
      padding: 20px;
      border-bottom: 1px solid #e4e7ed;
      flex-shrink: 0;

      h2 {
        margin: 0;
        font-size: 20px;
        color: #333;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        color: #909399;
      }
    }

    .page-content {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
    }

    .empty-content {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>
